<div class="modal-dialog modal-dialog-centered" role="document">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title">Számlázás új cégnek</h5>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body p-3">
			<%- include('/ui/form', {
				params: [ 'invoice_customer', invoice_customer_form, {
					label_width: 3
				} ],
				fields: [
					{
						type: 'select',
						name: 'company_id',
						title: 'Cég',
						params: {
							maxItems: 1,
							options: Anvil.page.modal.companies.data.filter(company => !!company.uuid),
							valueField: 'id',
							labelField: 'name',
							searchField: [ 'tax_number', 'name' ],
							render: {
								item: (item, esc) => `<div>${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`,
								option: (item, esc) => `<div class="option">${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`
							}
						},
						unset_value: null
					}
				]
			}) %>
		</div>

		<div class="modal-footer">
			<button type="button" class="btn btn-primary" onclick="Anvil.page.modal.confirm()"><i class="fa fa-check me-2"></i>Tovább</button>
		</div>
	</div>
</div>
<script>
Anvil.page.modal = Object.assign(Anvil.page.modal, {

	confirm () {
		const form = Anvil.page.modal.invoice_customer_form
		if (form.company_id) {
			Anvil.page.modal.close()
			Anvil.page.invoicing(form.company_id)
		}
	}
})
</script>
